import { http } from '@/http'

export default {
  list(data, params) {
    return http.post('/api/v1/audit-logs/list', data, {params})
  },
  download(data) {
    return http.post('/api/v1/audit-logs/xlsx', data, {responseType: 'blob'})
  }
}
